import TemplateView from "../TemplateView"

export default class CheckboxIcon extends TemplateView {

    constructor() {
        super()

        this.state = {
            checked: false,
            disabled: false,
            indeterminate: false,
        }

        this.onAnyStatePropertyChanged(['checked', 'disabled', 'indeterminate'], ({checked, disabled, indeterminate}) => {
            //checkbox can't be checked and indeterminate simultaneously
            this.$el.toggleClass("checked", !indeterminate && checked)
            this.$el.toggleClass("disabled", disabled)
            this.$el.toggleClass("indeterminate", indeterminate)
        })
    }

    templateHtml() {
        return '<div class="components_checkboxIcon"/>'
    }
}


// WEBPACK FOOTER //
// ./web/js/components/CheckboxIcon.js